import Button from "./Button";
import PropTypes from "prop-types";
import React from "react";
import { withTheme } from "styled-components";

function SmallCircleButton({ children, onClick, theme, testHook }) {
  return (
    <Button
      height={[22, null, 37, null]}
      width={[22, null, 37, null]}
      display="flex"
      justifyContent="center"
      alignItems="center"
      borderRadius="50%"
      borderStyle="solid"
      borderWidth="2px"
      borderColor={theme.colors.foreground}
      onClick={onClick}
      padding={["4px", null, 0, null]}
    >
      {children}
    </Button>
  );
}

SmallCircleButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default withTheme(SmallCircleButton);
